"use client";

import { LottieFileTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import LottieFileInPage from "../../lib/lottie-files/LottieFileInPage";
import { useTranslation } from "@/hooks/localization/useTranslations";

const SearchWelcome = () => {
  const t = useTranslation();
  return (
    <LottieFileInPage
      lottieFileType={LottieFileTypes.search}
      title={t.looking_for_something}
      text={t.just_type_something_in_search_box}
    />
  );
};

export default SearchWelcome;
